<template lang="html">

  <section class="slider-promos">


    <slick ref="slick" :options="slickOptions">
      <article class="slide" data="autoconsumo">
        <div class="slide-container container row-between ais">
          <div class="contenedor-imagen">
            <h2 class="titulo-mvl">
              <span class="-white">Instalación</span>
              <span class="-white">autoconsumo</span>
            </h2>
            <div class="contenedor-titulo row-center">
              <!-- <router-link :to="$t('enlaces.autoconsumo_tarifas')" class="btn -skull-orange -gray-c">Ver Tarifas -->
              <!-- </router-link> -->
            </div>
          </div>
          <div class="contenedor-textos">
            <h2>
              <span class="-white">Instalación</span>
              <span class="-white">autoconsumo</span>
            </h2>
            <div class="info-principal">
              <h3 class="tipo-tarifa -purple">
                Tu instalación <strong>desde</strong>

              </h3>
              <h4 class="precio" v-if="!!precios">
                <strong>3.500</strong><span>€</span>
              </h4>
            </div>

            <div class="contenedor-botones row-center">
              <router-link :to="$t('enlaces.autoconsumo')" title="Contrata" class="btn -degree">Saber más</router-link>
              <!-- <router-link :to="$t('enlaces.autoconsumo_tarifas')" class="btn -skull-orange -gray-c">Ver Tarifas -->
              </router-link>
            </div>
          </div>
        </div>
      </article>
      <article class="slide" data="helado">
        <div class="slide-container container row-between ais">
          <div class="contenedor-imagen">
            <h2 class="titulo-mvl">
              <span class="-white">Encuentra tu</span>
              <span class="-white">tarifa</span>
            </h2>
            <div class="contenedor-titulo row-center">
              <h2>Luz a precio<br>de un helado</h2>
              <router-link :to="$t('enlaces.tarifas_luz')" class="btn -skull-orange -gray-c">Ver Tarifas Luz
              </router-link>
            </div>
          </div>
          <div class="contenedor-textos">
            <h2>
              <span class="-white">Encuentra tu</span>
              <span class="-white">tarifa</span>
            </h2>
            <div class="info-principal">
              <h3 class="tipo-tarifa">
                Tu tarifa de <strong>Luz</strong>
              </h3>
              <h3 class="precio-coste">a precio de coste +</h3>
              <h4 class="precio" v-if="!!precios">
                <strong>{{precios.cuotaluz}}</strong><span>€ / mes</span>
              </h4>
              <h5 class="cuota-fija">Cuota fija mensual</h5>
            </div>

            <div class="contenedor-botones row-start">
              <router-link :to="$t('enlaces.contacto')" title="Contrata" class="btn -degree">Quiero
                inergizarme ya</router-link>
              <router-link :to="$t('enlaces.tarifas_luz')" class="btn -skull-orange -gray-c">Ver Tarifas Luz
              </router-link>
            </div>
          </div>
        </div>
      </article>







      <article class="slide" data="batido">
        <div class="slide-container container row-between ais">
          <div class="contenedor-imagen">
            <h2 class="titulo-mvl">
              <span class="-white">Encuentra tu</span>
              <span class="-white">tarifa</span>
            </h2>
            <div class="contenedor-titulo row-center">
              <h2>Gas a precio<br>de un batido</h2>
              <router-link :to="$t('enlaces.tarifas_gas')" class="btn -skull-orange -gray-c">Ver Tarifas Gas
              </router-link>
            </div>
          </div>
          <div class="contenedor-textos">
            <h2>
              <span class="-white">Encuentra tu</span>
              <span class="-white">tarifa</span>
            </h2>
            <div class="info-principal">
              <h3 class="tipo-tarifa -orange">
                Tu tarifa de <strong>Gas</strong>

              </h3>
              <h3 class="precio-coste -orange">a precio de coste +</h3>
              <h4 class="precio" v-if="!!precios">
                <strong>{{precios.cuotagas}}</strong><span>€ / mes</span>
              </h4>
              <h5 class="cuota-fija -white">Cuota fija mensual</h5>
            </div>

            <div class="contenedor-botones row-start">
              <router-link :to="$t('enlaces.contacto')" title="Contrata" class="btn -degree">Quiero
                inergizarme ya</router-link>
              <router-link :to="$t('enlaces.tarifas_gas')" class="btn -skull-orange -gray-c">Ver Tarifas Gas
              </router-link>
            </div>
          </div>
        </div>
      </article>


      <article class="slide" data="helado-batido">
        <div class="slide-container container row-between ais">
          <div class="contenedor-imagen">
            <h2 class="titulo-mvl">
              <span class="-white">Encuentra tu</span>
              <span class="-white">tarifa</span>
            </h2>
            <div class="contenedor-titulo row-center">
              <h2>Luz y gas a precio de una muffin</h2>
              <router-link :to="$t('enlaces.tarifas_luzgas')" class="btn -skull-orange -gray-c">Ver Tarifas
              </router-link>
            </div>
          </div>
          <div class="contenedor-textos">
            <h2>
              <span class="-white">Encuentra tu</span>
              <span class="-white">tarifa</span>
            </h2>
            <div class="info-principal">
              <h3 class="tipo-tarifa -white">
                Tu tarifa <strong>Luz y Gas</strong>
              </h3>
              <h3 class="precio-coste -white">a precio de coste +</h3>
              <h4 class="precio" v-if="!!precios">
                <i class="old -orange">{{precios.cuotaoldluzgas}}</i>
                <strong>{{precios.cuotaluzgas}}</strong><span>€ / mes</span>
              </h4>
              <h5 class="cuota-fija -white">Cuota fija mensual</h5>
            </div>

            <div class="contenedor-botones row-start">
              <router-link :to="$t('enlaces.contacto')" title="Contrata" class="btn -degree">
                Quiero inergizarme ya</router-link>
              <router-link :to="$t('enlaces.tarifas_luzgas')" class="btn -skull-orange -gray-c">Ver Tarifas
              </router-link>
            </div>
          </div>
        </div>
      </article>







    </slick>


  </section>

</template>

<script lang="js">


  import Slick from 'vue-slick';

  import { mapGetters } from 'vuex';


  export default {
    name: 'slider-promos',
    components: { Slick },
    data() {
      return {
        slickOptions: {
          slidesToShow: 1,
          // autoplay:true,
          autoplaySpeed: 5000
        },
      }
    },
    computed: {
      ...mapGetters({
        precios: 'getPrecios'
      })
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/css/colors.scss';

  .slide {
    padding-top: 150px;
    background: #ffc422;

    &[data="helado"] {
      background: #ffd153;

      .slide-container {
        &::before {
          background: url("/static/img/background-baratos.jpg") center left/auto 100% no-repeat;
          content: '';
          display: inline-block;
          width: 600px;
          height: 600px;
          position: absolute;
          left: -80px;
          bottom: 0;

        }
      }
    }

    &[data="batido"] {
      background: $purple;

      .slide-container {
        &::before {
          background: url("/static/img/batido.jpg") center center/auto 100% no-repeat;
          content: '';
          display: inline-block;
          width: 400px;
          height: 600px;
          position: absolute;
          left: 30px;
          bottom: -20px;
        }
      }
    }

    &[data="helado-batido"] {
      background: #FFD243;

      .slide-container {
        &::before {
          background: url("/static/img/fondo-batido.jpg") center center/auto 100% no-repeat;
          content: '';
          display: inline-block;
          width: 550px;
          height: 620px;
          position: absolute;
          left: -60px;
          bottom: 00px;
        }
      }
    }

    &[data="autoconsumo"] {
      background: $yellow;

      .slide-container {
        &::before {
          background: url("/static/img/autoconsumo/placa-solar-mvl.png") center right/100% auto no-repeat;
          content: '';
          display: inline-block;
          width: 500px;
          height: 520px;
          position: absolute;
          left: -62px;
          bottom: 0px;
        }
      }
    }

  }

  .slide-container {
    padding-bottom: 50px;
    position: relative;

    &::before {
      /*transform: perspective(100px) translateZ(-20px);*/
      transform: translateY(200%);
      will-change: transform, opacity;
      opacity: 0;
      transition-delay: 2s;
    }
  }

  .titulo-mvl {
    display: none;
  }


  [data="helado-batido"] .info-principal .precio,
  [data="helado-batido"] .info-principal .cuota-fija {
    position: relative;
    padding-left: 140px;
  }


  .contenedor-titulo {
    width: 425px;
    height: 425px;
    border: 3px solid white;
    padding: 20px;
    position: relative;
    z-index: 2;
    opacity: 0;
    will-change: transform, opacity;
    transition-delay: 2s;

    h2 {
      color: white;
      font-size: 45px;
      line-height: 50px;
      font-weight: 800;
      transform: translateY(100px) perspective(100px) translateZ(-30px);
      opacity: 0;
      transition-delay: 2s;
      margin-bottom: 0;

      i {
        font-size: 30px;
        width: 100%;
        display: inline-block;
        font-style: normal;
      }

    }

    .btn {
      display: none;
    }

  }

  .contenedor-textos {
    width: calc(100% - 425px);
    padding-left: 100px;
    text-align: left;
    position: relative;
    z-index: 2;

    h2 {
      position: relative;
      text-align: left;

      span:first-of-type {
        font-size: 30px;
        line-height: .9em;
        font-weight: 800;
        position: absolute;
        left: -50px;
        top: 0;
        bottom: auto;
        width: auto;
        display: inline-block;
        text-transform: initial;
        text-align: left;
        color: rgba(255, 255, 255, .7);
        transform: translateY(-50px);
        opacity: 0;
        transition-delay: 2s;
      }

      span:last-of-type {
        font-size: 80px;
        text-transform: uppercase;
        font-weight: 800;
        line-height: .9em;
        left: auto;
        margin-top: 10px;
        position: relative;
        color: rgba(255, 255, 255, .3);
        transform: translateY(50px);
        opacity: 0;
        transition-delay: 2s;
      }
    }
  }


  .contenedor-botones {

    transform: translateY(50px);
    opacity: 0;

    .btn:first-of-type {
      margin-right: 30px;
    }

  }


  .slick-current {

    .contenedor-titulo h2 {
      transition: .8s;
      transition-delay: 1.3s;
      transition-timing-function: ease-in-out;
      transform: none;
      opacity: 1;
    }

    .slide-container {

      &::before {
        transition: 1.2s;
        transition-delay: 1s;
        transition-timing-function: ease-in-out;
        transform: none;
        opacity: 1;
      }

      .contenedor-titulo {
        transition: .8s;
        transition-delay: .8s;
        transition-timing-function: ease-in-out;
        transform: none;
        opacity: 1;


      }


    }

    .contenedor-textos h2 span {
      transition: .5s;
      transition-delay: 1.8s;
      transition-timing-function: ease-in-out;
      transform: none;
      opacity: 1;
    }

    .info-principal .tipo-tarifa {
      transition: .7s;
      transition-delay: 2.3s;
      transition-timing-function: ease-in-out;
      transform: none;
      opacity: 1;
    }

    .info-principal .precio-coste {
      transition: .7s;
      transition-delay: 2.7s;
      transition-timing-function: ease-in-out;
      transform: none;
      opacity: 1;
    }

    .info-principal .precio {
      strong {
        transition: 1s;
        transition-delay: 3s;
        transition-timing-function: ease-in-out;
        transform: none;
        opacity: 1;
      }

      span {
        transition: .5s;
        transition-delay: 3.4s;
        transition-timing-function: ease-in-out;
        transform: none;
        opacity: 1;
      }

      i {
        transition: .5s;
        transition-delay: 3s;
        transition-timing-function: ease-in-out;
        transform: none;
        opacity: 1;
      }
    }

    .info-principal .cuota-fija {
      transition: .5s;
      transition-delay: 3.7s;
      transition-timing-function: ease-in-out;
      transform: none;
      opacity: 1;
    }

    .contenedor-botones {
      transition: .5s;
      transition-delay: 4s;
      transition-timing-function: ease-in-out;
      transform: none;
      opacity: 1;
    }





  }

  @keyframes reset {
    to {
      transform: none;
      opacity: 1;
    }
  }

  @media screen and (max-width: 1100px) {

    .contenedor-textos {
      padding-left: 40px;

      h2 {
        span:first-of-type {
          left: -10px;
        }
      }
    }

    .contenedor-botones .btn:first-of-type {
      margin-right: 15px;
    }

  }


  @media screen and (max-width: 1023px) {


    .slide {
      padding-top: 100px;
      overflow: hidden;
    }

    .contenedor-botones .btn.-skull-orange {
      display: none;
    }



    .slide-container {
      align-items: center;
      justify-content: center;
      -webkit-justify-content: center;
    }

    .contenedor-imagen {
      width: 320px;
      height: 320px;
    }

    .slide[data="autoconsumo"] .slide-container::before {
      display: none;
    }

    .slide[data="autoconsumo"] .slide-container .contenedor-imagen {
      position: relative;
    }

    .slide[data="autoconsumo"] .slide-container .contenedor-imagen::before {
      background: url("/static/img/autoconsumo/placa-solar-mvl.png") center right/100% auto no-repeat;
      content: '';
      display: inline-block;
      width: 380px;
      height: 370px;
      right: 0px;
      bottom: -20px;
      position: absolute;
    }


    .contenedor-textos {
      max-width: calc(100% - 320px);
      width: calc(100% - 320px);
    }

    .slide-container .contenedor-titulo {

      width: 320px;
      height: 320px;

      -webkit-flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -o-flex-direction: column;
      flex-direction: column;

      h2 {
        margin-bottom: 20px;
        font-size: 38px;
      }

      .btn {
        display: inline-block;
      }
    }


    .contenedor-textos {
      max-width: 100%;
      width: auto;

      h2 {
        margin-bottom: 30pX;

        span:last-of-type {
          font-size: 56px;
        }
      }
    }

    .info-principal {
      padding-left: 0;
      margin-bottom: 30px;

      .precio {
        font-size: 24px;
        line-height: 76px;

        strong {
          font-size: 100px;
        }

        i {
          font-size: 50px;
        }
      }
    }

    [data="helado-batido"] .info-principal .precio,
    [data="helado-batido"] .info-principal .cuota-fija {
      padding-left: 100px;
    }

  }

  @media screen and (max-width: 920px) {

    .slide[data="helado-batido"] .slide-container::before {
      left: -120px;
    }

  }

  @media screen and (max-width: 800px) {

    .contenedor-titulo h2 {
      font-size: 36px;
      line-height: 40px;
      margin-bottom: 30px;
    }

    .contenedor-textos h2 {
      margin-bottom: 15px;
    }

    .info-principal .tipo-tarifa {
      font-size: 28px;
    }

    .info-principal .precio-coste {
      font-size: 24px;
    }

    .info-principal .precio strong {
      font-size: 80px;
    }

    .slick-current .info-principal .precio i {
      font-size: 36px;

      &::before {
        bottom: 15px;
      }
    }

    [data="helado-batido"] .info-principal .precio,
    [data="helado-batido"] .info-principal .cuota-fija {
      padding-left: 75px;
    }

    .contenedor-botones .btn {
      font-size: 12px;
      margin-right: 0;
    }

    .slide[data="helado"] .slide-container::before {
      width: 400px;
      height: 400px;
      left: -20px;
    }

    .slide[data="batido"] .slide-container::before {
      width: 400px;
      height: 400px;
      left: -20px;
    }


    .slide[data="autoconsumo"] .slide-container .contenedor-imagen {
      margin-bottom: 20px;
    }



  }


  @media screen and (max-width: 750px) {

    .slide[data="helado"],
    .slide[data="batido"],
    .slide[data="helado-batido"],
    .slide[data="autoconsumo"] {
      background: white;

      .slide-container {
        &::before {
          display: none;
        }
      }
    }



    .slide-container {
      -webkit-flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -o-flex-direction: column;
      flex-direction: column;
      padding: 0;
    }

    .slide {
      padding-top: 0;
    }

    .contenedor-textos h2 {
      display: none;
    }

    .titulo-mvl {
      position: absolute;
      display: inline-block;
      top: 90px;
      width: 100%;
      text-align: left;
      max-width: 320px;

      span:first-of-type {
        font-size: 25px;
        line-height: .9em;
        font-weight: 800;
        position: absolute;
        left: -20px;
        top: 0;
        bottom: auto;
        width: auto;
        display: inline-block;
        text-transform: initial;
        text-align: left;
        color: rgba(255, 255, 255, .8);

      }

      span:last-of-type {
        font-size: 60px;
        text-transform: uppercase;
        font-weight: 800;
        line-height: .9em;
        left: auto;
        margin-top: 10px;
        position: relative;
        color: rgba(255, 255, 255, .5);
      }
    }

    .info-principal .precio {
      color: $orange;
      line-height: 50px;
    }

    .info-principal .cuota-fija {
      font-size: 16px;
    }

    .contenedor-botones {
      justify-content: center;
      -webkit-justify-content: center;
    }

    .contenedor-imagen {
      width: 100%;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      justify-content: center;
      -webkit-justify-content: center;
      height: auto;
      padding: 40px;
      padding-top: 200px;
    }

    .slide[data="helado"] {
      .contenedor-imagen {
        background: #ffd153 url("/static/img/background-baratos.jpg") center bottom/auto 85% no-repeat;
      }
    }

    .slide[data="batido"] {
      .contenedor-imagen {
        background: #5E639F url("/static/img/batido.jpg") center bottom/auto 80% no-repeat;
      }
    }

    .slide[data="helado-batido"] {
      .contenedor-imagen {
        background: #FFD243 url("/static/img/fondo-batido.jpg") center bottom/auto 90% no-repeat;
      }
    }

    .slide[data="autoconsumo"] {
      .contenedor-imagen {
        background: $yellow;
      }
    }

    .slide[data="autoconsumo"] .slide-container .contenedor-imagen::before {
      display: none;
    }

    .slide[data="autoconsumo"] .slide-container .contenedor-titulo::before {
      background: url(/static/img/autoconsumo/placa-solar-mvl.png) center right/100% auto no-repeat;
      content: '';
      display: inline-block;
      width: 380px;
      height: 370px;
      right: 0px;
      bottom: -20px;
      position: absolute;
    }

    .slide .slide-container .contenedor-imagen{
      padding-top: 150px;
    }

    .slide .titulo-mvl{
      top: 80px;
    }

    .slide .titulo-mvl span:last-of-type{
      font-size: 45px;
    }


    .info-principal {
      margin-bottom: 15px;
    }

    .contenedor-textos {
      padding: 0 15px;
      margin-top: 20px;
      width: 100%;
      max-width: 400px;
    }

    .contenedor-botones {
      justify-content: center;
      -webkit-justify-content: center;
    }

    .contenedor-botones .btn {
      font-size: 14px;

      &:first-of-type {
        margin-right: 0;
      }
    }

    .info-principal .tipo-tarifa.-white,
    .info-principal .tipo-tarifa.-orange {
      color: $dark;
    }

    .info-principal .precio-coste.-white,
    .info-principal .precio-coste.-orange,
    .info-principal .precio .old.-orange {
      color: $dark-orange;
    }

    .info-principal .cuota-fija {
      color: $purple;
    }


    .info-principal .tipo-tarifa {
      text-align: center;
    }

    .info-principal .precio {
      text-align: center;
    }

    .info-principal .cuota-fija {
      text-align: center;
    }


    [data="helado-batido"] .info-principal .cuota-fija {
      padding-left: 0;
    }

    [data="helado-batido"] .info-principal .precio {
      text-align: left;
    }


  }

  @media screen and (max-width: 600px) {

    .titulo-mvl {
      top: 20px;
    }

    .contenedor-imagen {
      padding-top: 100px;
    }

  }

  @media screen and (max-width: 500px) {

    .contenedor-imagen {
      padding-left: 20px;
      padding-right: 20px;
    }

    .slide-container .contenedor-titulo {
      width: 100%;
    }

  }

  @media screen and (max-width: 390px) {

    .titulo-mvl {
      max-width: 280px;

      span:first-of-type {
        left: -10px;
      }
    }

    .slide .titulo-mvl span:last-of-type{
      font-size: 40px;
    }

  }
</style>


// WEBPACK FOOTER //
// src/components/parts/slider-promos.vue